<div class="container min-vh-100 position-relative p-0 overflow-hidden register-container">

  <!-- Decorative Images -->
  <img src="../assets/images/Group1.png" alt=""
    class="side-images d-none d-sm-block d-md-block position-absolute top-0 start-0">
  <img src="../assets/images/Group2.png" alt=""
    class="side-images d-none d-sm-block d-md-block position-absolute bottom-0 end-0 ">

  <div class="row g-0 min-vh-100 d-none d-lg-flex fixed-col" *ngIf="showMainTab">
    <!-- Left Column (Updated for iPad) -->
    <div class="col-12 col-md-6 col-lg-6 bg-white p-5 fixed-col d-flex align-items-center justify-content-center" style="margin-bottom: 5px !important;">
      <div class="gap-3 d-flex flex-column">
        <div class="login-left-container logo-tagline" >
          <div class="logo-div"><img src="assets/images/VisitorBridgeLogo (1).png" alt="Logo" class="img-fluid vb-logo"></div>
          <div class="tagline">
            <!-- <div class="tagline"><p>Seamless welcomes, connected experiences</p></div> -->
            <p>
              <span class="color1">Seamless</span>
              <span class="color2">Welcomes</span>
            </p>
            <p>
              <span class="color2">Connected</span>
              <span class="color1">Experiences</span>
            </p>
          </div>
          </div>
        <div class="login-left-container"><img src="assets/images/VB_Final_GIF.gif" alt="Visual" class="img-fluid visual-img"></div>

        <div class="login-left-container">
          <div class="d-flex flex-column powered-by-lg">
            <small class="text-center text-black mb-1">Powered by</small>
            <img src="assets/images/dnvLogo.png" alt="DNV Logo" class="img-fluid dnv-img">
          </div>           
        </div>
      </div>
    </div>

    <!-- Right Column (Adjusted for iPad) -->
    <div class="col-12 col-md-6 d-flex align-items-center justify-content-center form-col">
      <div class="w-100 px-3 px-md-4 px-lg-5" style="max-width: 500px;">
        <div class="card border-0 shadow-lg rounded-4 register-card" *ngIf="showTabRegister">
          <div class="card-body p-3 p-md-4 p-lg-5 mb-2">
            <h2 class="mb-1 fw-bolder fs-10">Registration</h2>
            <p class="text-muted mb-4">Enter your company email to register and Verify your account</p>

            <form class="needs-validation" name="event-form" id="form-event" #registerForm="ngForm"
              (ngSubmit)="registerForm.valid && registerUser(registerForm)" novalidate>
              <div class="mb-4">
                <div *ngIf="(email.touched || registerForm.submitted) && email.invalid"
                  class="alert alert-danger d-flex align-items-center gap-2 p-2 mb-3 rounded">
                  <img src="assets/icons/jam_alert-f.png" />
                  <span *ngIf="email.errors?.['required']">Email address is required</span>
                  <span *ngIf="email.errors?.['email']">Invalid email address</span>
                </div>
                <div class="input-group"
                  [ngClass]="{'is-invalid': (email.touched || registerForm.submitted) && email.invalid}">
                  <span class="input-group-text border-end-0">
                    <img src="assets/icons/email.png" />
                  </span>
                  <input type="email" class="form-control border-start-0" placeholder="Email address" name="email"
                    [(ngModel)]="user.email" #email="ngModel" required email
                    [ngClass]="{'error': email.touched || registerForm.submitted && email.invalid}">
                </div>
              </div>
              <button class="btn btn-bg fw-bolder w-100 py-2 fs-5 register-button rounded button-animations text-white" type="submit" [disabled]="formSubmitLoader">
                Get OTP
                <i *ngIf="formSubmitLoader" class="spinner-border spinner-border-sm ms-2"></i>
              </button>
              <div class="text-center mt-5 mb-5">
                <p class="mb-0">Already have an account?
                  <a class="text-link fw-bolder" routerLink="/login">Login</a>
                </p>
              </div>
            </form>
          </div>
        </div>
        <div class="card border-0 shadow-lg rounded-4 register-card " *ngIf="showTabVerifyOTP">
          <div class="card-body p-3 p-md-4 p-lg-5">
            <h2 class="mb-3 fw-bolder fs-10">Enter OTP</h2>
            <p class="text-muted mb-1">
              <img src="assets/icons/Mask group (1).png" class="ml-2" /> 4 digit OTP sent to your email on
            </p>
            <p class="fw-bold text-dark ml-2">{{ user.email }}</p>

            <form class="needs-validation" name="event-form" id="form-event" #otpForm="ngForm"
              (ngSubmit)="verifyOTP(otpForm)" novalidate>


              <div class="alert alert-danger d-flex align-items-center gap-2 p-2 mb-3 rounded"
                *ngIf="(otp[0] === '' || otp[1] === '' || otp[2] === '' || otp[3] === '') && otpForm.submitted">
                <img src="assets/icons/jam_alert-f.png" /> Please enter correct OTP.
              </div>

              <!-- <div class="alert alert-danger d-flex align-items-center py-2 px-3 mb-3"
                *ngIf="otpError & otp[0] && otp[1] && otp[2] && otp[3]">
                <i class="bi bi-exclamation-circle-fill me-2"></i>
                <span>Please enter correct OTP</span>
              </div> -->

              <div class="d-flex justify-content-between otp-container mb-3">
                <input type="tel" class="otp-box otp-input-0" maxlength="1" [(ngModel)]="otp[0]"
                  (input)="onOtpInput($event, 0)" (keydown)="onOtpKeyDown($event, 0)" name="otp0" required>
                <input type="tel" class="otp-box otp-input-1" maxlength="1" [(ngModel)]="otp[1]"
                  (input)="onOtpInput($event, 1)" (keydown)="onOtpKeyDown($event, 1)" name="otp1" required>
                <input type="tel" class="otp-box otp-input-2" maxlength="1" [(ngModel)]="otp[2]"
                  (input)="onOtpInput($event, 2)" (keydown)="onOtpKeyDown($event, 2)" name="otp2" required>
                <input type="tel" class="otp-box otp-input-3" maxlength="1" [(ngModel)]="otp[3]"
                  (input)="onOtpInput($event, 3)" (keydown)="onOtpKeyDown($event, 3)" name="otp3" required>
              </div>
              

              <!-- <div class="invalid-feedback"
                *ngIf="(otp[0] === '' || otp[1] === '' || otp[2] === '' || otp[3] === '') && otpForm.submitted">
                <span>Please enter the complete OTP.</span>
              </div> -->
              <!-- Terms of Service Checkbox -->
              <div class="form-check mt-2 mb-3">
                <input type="checkbox" class="form-check-input" id="termsCheck" [(ngModel)]="termsAccepted"
                  name="termsAccepted" required>
                <label class="form-check-label text-muted termspolicy" for="termsCheck">
                  By signing up you agree to the
                  <!-- <a href="/#" class="text-link fw-bolder">Terms of Service</a> and -->
                  <a href="/#" class="text-link fw-bolder" data-bs-toggle="modal" data-bs-target="#privacyModal" (click)="openPrivacyModal()">Privacy Policy</a>
                </label>
              </div>
              <div class="mt-4 timerResend text-center">
                   <p id="timer">Remaining time: <a id="time">{{ formatTimer() }}</a></p>
                  <a id="resendOtp" style="background: none;" class="text-link fw-bolder"
                    (click)="canResend && !formSubmitLoader && resendOtp(); $event.preventDefault()"
                    [class.disabled]="!canResend || formSubmitLoader"
                    [attr.disabled]="(!canResend || formSubmitLoader) ? true : null">Resend OTP</a>
                </div>
              <!-- Verify & Register Button -->
              <button class="btn btn-bg fw-bolder w-100 py-2 fs-5 register-button rounded button-animations text-white" type="submit">
                Verify & Register
              </button>
              <div class="modal fade show d-block" tabindex="-1" role="dialog" *ngIf="showTermsModal">
                <div class="modal-dialog modal-dialog-centered modal-md " role="document">
                  <div class="modal-content text-center ml-2 rounded-5 shadow">
                    <div class="modal-body p-5">
                      <div class="mb-3">
                        <img src="assets/icons/iconoir_privacy-policy.png" class="img-fluid" />
                      </div>
                      <h5 class="modal-title fw-bolder mb-2">Policy Acceptance</h5>
                      <!-- <p class="text-muted mb-4">Please accept the Terms of Service and <br>
                        Privacy Policy to continue.</p> -->
                      <p class="text-muted mb-4">Please accept the Privacy Policy to continue.</p>
                      <button type="button" class="btn btn-bg w-100 button-animations text-white" (click)="closeTermsModal()">I
                        Agree</button>
                    </div>
                  </div>
                </div>
              </div>


            </form>

             
            <!-- <div class="text-center mt-3">
              <p class="mb-0">
                <a class="text-link fw-bolder" routerLink="/login">Resend OTP</a>
              </p>
            </div> -->
            <div class="text-center mt-4">
              <p class="mb-0">Already have an account?
                <a class="text-link fw-bolder" routerLink="/login">Login</a>
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
    <div class="row g-0 min-vh-100 d-none d-lg-flex" *ngIf="showSuccessTab">
    <img src="assets/images/honeycomb-pattern.svg" alt="Honeycomb Background" class="honeycomb-bg position-absolute top-0 start-0">
    <div class="col-12 d-flex flex-column align-items-center justify-content-center">
      <div class="w-100 px-3 px-md-4 px-lg-5" style="max-width: 500px;">
        <div class="text-center mb-2">
          <img src="assets/images/Visitors-Bridge-logo.svg" alt="Visitor Bridge Logo" class="img-fluid mobile-logo">
        </div>
        
          <div class="text-center p-3 p-md-4 p-lg-5">
            <div class="mb-4">
              <div class="d-inline-block p-3 rounded-circle bg-light-success">
                <div class="d-inline-block p-3 rounded-circle bg-success-1">
                  <img src="assets/icons/Group.png" />
                </div>
              </div>
            </div>
            <h2 class="text-successfull">Successfull!</h2>
            <p class="text-muted mb-4">Your account has been created. <br> Please check your email for further
              instructions.</p>
            <button class="btn btn-primary w-100 mobile-login-button button-animations" style="margin-top: 100px;" routerLink="/login">Go to Login</button>
         
        </div>
        
      </div>
    </div>
  </div>

  <div class="row g-0 min-vh-100 d-flex d-lg-none mobile-view" *ngIf="showMainTab">
    <img src="assets/images/honeycomb-pattern.svg" alt="Honeycomb Background" class="honeycomb-bg position-absolute top-0 start-0">
    <div class="col-12 d-flex flex-column align-items-center justify-content-center">
      <div class="position-absolute top-0 start-0 m-3">
        <a routerLink="/splash">
          <img src="assets/images/arrow-back.svg" alt="back" >
        </a>
      </div>
      <div class="mobile-login-container px-md-4 px-lg-5">

        <!-- Logo -->
        <div class="text-center mb-2">
          <img src="assets/images/Visitors-Bridge-logo.svg" alt="Visitor Bridge Logo" class="img-fluid mobile-logo">
        </div>

        <!-- GIF -->
        <div class="d-flex justify-content-center align-items-center">
          <img src="assets/images/VB_Final_GIF.gif" alt="Visual" class="login-illustration img-fluid">
        </div>
        
        <div *ngIf="showTabRegister">
          <div class="text-center p-md-4 p-lg-5 ">
            <h2 class="register">Register</h2>
            <p class="text-muted">Enter your company email to register and
              verifiy your account</p>
          </div>
          <form class="needs-validation" name="event-form" id="form-event" #registerForm="ngForm"
            (ngSubmit)="registerForm.valid && registerUser(registerForm)" novalidate>
            <div class="mb-3">
              <div class="error-container" *ngIf="(email.touched || registerForm.submitted) && email.invalid">
                <img src="assets/icons/jam_alert-f.png" />
                <span class="error-msg" *ngIf="email.errors?.['required']">Email address is required</span>
                <span class="error-msg" *ngIf="email.errors?.['email']">Invalid email address</span>
              </div>
              <div class="mobile-input-group"
                [ngClass]="{'is-invalid': (email.touched || registerForm.submitted) && email.invalid}">
                <span class="input-icon">
                  <img src="assets/icons/email.png" />
                </span>
                <input type="email" class="form-control border-start-0" placeholder="Email address" name="email"
                  [(ngModel)]="user.email" #email="ngModel" required email
                  [ngClass]="{'error': email.touched || registerForm.submitted && email.invalid}">
              </div>
            </div>
            <!-- <button class="btn btn-bg fw-bolder w-100 py-2 fs-5 register-button rounded" type="submit" [disabled]="formSubmitLoader">
                                Get OTP
                                <i *ngIf="formSubmitLoader" class="spinner-border spinner-border-sm ms-2"></i>
                              </button> -->
            <button class="btn btn-primary w-100 py-2 mobile-login-button button-animations text-white" type="submit">
              Get OTP
            </button>

            <div class="or-container text-center mt-4">
              <span class="or-divider">Or</span>
            </div>

            <div class="text-center mb-3">
              <p class="mb-2">Already have an account? <a class="mobile-login" routerLink="/login">Login now</a></p>
            </div>
          </form>
        </div>

        <div *ngIf="showTabVerifyOTP">
          <div class="text-center p-3 p-md-4 p-lg-5">
            <h2 class="register">Enter OTP</h2>
            <p class="text-muted mb-1">
              <img src="assets/icons/Mask group (1).png" class="ml-2" /> 4 digit OTP sent to your email on
            </p>
            <p class="fw-bold text-dark ml-2" style=" font-size: 16px;">{{ user.email }}</p>
          </div>
            <form class="needs-validation" name="event-form" id="form-event" #otpForm="ngForm"
            (ngSubmit)="verifyOTP(otpForm)" novalidate>
            <div class="alert alert-danger d-flex align-items-center gap-2 p-2 mb-3 rounded"
              *ngIf="(otp[0] === '' || otp[1] === '' || otp[2] === '' || otp[3] === '') && otpForm.submitted">
              <img src="assets/icons/jam_alert-f.png" />
              <span class="error-msg">Please enter correct OTP.</span> 
            </div>

            <!-- <div class="alert alert-danger d-flex align-items-center py-2 px-3 mb-3"
              *ngIf="otpError & otp[0] && otp[1] && otp[2] && otp[3]">
              <i class="bi bi-exclamation-circle-fill me-2"></i>
              <span>Please enter correct OTP</span>
            </div> -->

            <div class="d-flex justify-content-between otp-container mb-3">
              <input type="tel" class="otp-box motp-input-0" maxlength="1" [(ngModel)]="otp[0]"
                (input)="onOtpInputMobile($event,0)" (keydown)="onOtpKeyDownMobile($event, 0)" name="otp0" required>
              <input type="tel" class="otp-box motp-input-1" maxlength="1" [(ngModel)]="otp[1]"
                (input)="onOtpInputMobile($event,1)" (keydown)="onOtpKeyDownMobile($event, 1)" name="otp1" required>
              <input type="tel" class="otp-box motp-input-2" maxlength="1" [(ngModel)]="otp[2]"
                (input)="onOtpInputMobile($event,2)" (keydown)="onOtpKeyDownMobile($event, 2)" name="otp2" required>
              <input type="tel" class="otp-box motp-input-3" maxlength="1" [(ngModel)]="otp[3]"
                (input)="onOtpInputMobile($event,3)" (keydown)="onOtpKeyDownMobile($event, 3)" name="otp3" required>
            </div>

            <!-- <div class="invalid-feedback"
              *ngIf="(otp[0] === '' || otp[1] === '' || otp[2] === '' || otp[3] === '') && otpForm.submitted">
              <span>Please enter the complete OTP.</span>
            </div> -->
            <!-- Terms of Service Checkbox -->
            <div class="form-check mt-2 mb-3">
              <input type="checkbox" class="form-check-input" id="termsCheck" [(ngModel)]="termsAccepted"
                name="termsAccepted" required>
              <label class="form-check-label text-muted termspolicy" for="termsCheck">
                By signing up you agree to the
                <!-- <a href="/#" class="text-link fw-bolder">Terms of Service</a> and -->
                <a href="/#" class="text-link fw-bolder" data-bs-toggle="modal" data-bs-target="#privacyModal" (click)="openPrivacyModal()">Privacy Policy</a>
              </label>
            </div>
            <div class="mt-4 timerResend text-center">
                   <p id="timer">Remaining time: <a id="time">{{ formatTimer() }}</a></p>
                  <a id="resendOtp" style="background: none;" class="text-link fw-bolder"
                    (click)="canResend && !formSubmitLoader && resendOtp(); $event.preventDefault()"
                    [class.disabled]="!canResend || formSubmitLoader"
                    [attr.disabled]="(!canResend || formSubmitLoader) ? true : null">Resend OTP</a>
                </div>
            <!-- Verify & Register Button -->
            <!-- <button class="btn btn-bg fw-bolder w-100 py-2 fs-5 register-button rounded" type="submit">
              Verify & Register
            </button> -->
            <button class="btn btn-primary w-100 py-2 mobile-login-button button-animations text-white" type="submit">
              Verify & Register
            </button>
            <div class="modal fade show d-block" tabindex="-1" role="dialog" *ngIf="showTermsModal">
              <div class="modal-dialog modal-dialog-centered modal-md " role="document">
                <div class="modal-content text-center ml-2 policy-modal shadow">
                  <div class="modal-body p-5">
                    <div class="mb-3">
                      <img src="assets/icons/iconoir_privacy-policy.png" class="img-fluid" />
                    </div>
                    <h5 class="modal-title fw-bolder mb-2">Policy Acceptance</h5>
                    <!-- <p class="text-muted mb-4">Please accept the Terms of Service and <br>
                      Privacy Policy to continue.</p> -->
                    <p class="text-muted mb-4">Please accept the  Privacy Policy to continue.</p>
                    <button type="button" class="btn btn-bg w-100 button-animations" (click)="closeTermsModal()">I
                      Agree</button>
                  </div>
                </div>
              </div>
            </div>


          </form>
        
            <!-- <div class="text-center mt-3">
              <p class="mb-0">
                <a class="text-link fw-bolder" routerLink="/login">Resend OTP</a>
              </p>
            </div> -->
            <!-- <div class="text-center mt-4">
              <p class="mb-0">Already have an account?
                <a class="text-link fw-bolder" routerLink="/login">Login</a>
              </p>
            </div> -->
          
        </div>

        <div class="text-center mt-3 d-flex flex-column align-items-center">
          <small class="mb-0">Powered By</small>
          <img src="assets/images/dnvLogo.png" alt="DNV Group Logo" class="img-fluid dnv-mobile-logo">
        </div>
        <div class="footer-links text-center mt-4">
          <!-- <a href="#">Terms of service</a>
          <span class="mx-2">·</span> -->
          <a href="#" data-bs-toggle="modal" data-bs-target="#privacyModal" (click)="openPrivacyModal()">Privacy policy</a>
          <!-- <span class="mx-2">·</span>
          <a href="#">Support</a> -->
        </div>
      </div>
    </div>
  </div>

  <div class="row g-0 min-vh-100 d-flex d-lg-none mobile-view" *ngIf="showSuccessTab">
    <img src="assets/images/honeycomb-pattern.svg" alt="Honeycomb Background" class="honeycomb-bg position-absolute top-0 start-0">
    <div class="col-12 d-flex flex-column align-items-center justify-content-center">
      <div class="w-100 px-3 px-md-4 px-lg-5" style="max-width: 500px;">
        <div class="text-center mb-2">
          <img src="assets/images/Visitors-Bridge-logo.svg" alt="Visitor Bridge Logo" class="img-fluid mobile-logo">
        </div>
        
          <div class="text-center p-3 p-md-4 p-lg-5">
            <div class="mb-4">
              <div class="d-inline-block p-3 rounded-circle bg-light-success">
                <div class="d-inline-block p-3 rounded-circle bg-success-1">
                  <img src="assets/icons/Group.png" />
                </div>
              </div>
            </div>
            <h2 class="text-successfull">Successfull!</h2>
            <p class="text-muted mb-4">Your account has been created. <br> Please check your email for further
              instructions.</p>
            <button class="btn btn-primary w-100 mobile-login-button button-animations" style="margin-top: 100px;" routerLink="/login">Go to Login</button>
         
        </div>
        
      </div>
    </div>
  </div>

  <!-- Privacy Policy Modal -->
  <div *ngIf="showPrivacyPolicy" class="main-modal" id="privacyModal" aria-labelledby="privacyModalLabel" aria-hidden="true">
    <div class="modal-main-content privacy-policy-container rounded-4 p-3">
      <div class="modal-header">
        <h5 class="modal-title fw-bold me-auto" id="privacyModalLabel">Privacy Policy</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closePrivacyModal()"></button>
      </div>

      <div class="modal-body pt-3 justify-text" style="height: 75dvh; overflow-y: auto !important; padding-right: 16px !important;">
        <p class="privacy-policy-text">
          <strong class="privacy-policy-text">VisitorBridge</strong> is the brandname of Visitor Management Solution provided by <strong class="privacy-policy-text">DNV
            Security Solutions Pvt Ltd</strong>.
          DNV Security Solutions Pvt Ltd (referred to as “DNV”, “we”, “our”, or “us”) values the privacy of all users of
          the VisitorBridge platform —
          including host organizations, their employees, and visitors. This Privacy Policy outlines how we collect, use,
          and safeguard information based on user type.
        </p>
  
        <hr>
  
        <h6 class="fw-bold privacy-policy-text">1. Privacy Policy for Host Organizations and Their Employees</h6>
        <p class="privacy-policy-text">
          This section applies to organizations that use VisitorBridge to manage visitor entry and their assigned
          employees (Admins, Super Admins, Hosts).
        </p>
        <p class="fw-bold mb-1 privacy-policy-text">Information We Collect:</p>
        <ul class="privacy-policy-text">
          <li>Organization Name</li>
          <li>Employee Names, Email IDs, Phone Numbers</li>
          <li>Role-based access information (e.g., Host, Admin)</li>
          <li>Audit trails and log activity</li>
          <li>Usage preferences and configuration settings</li>
        </ul>
        <p class="fw-bold mb-1">How We Use This Information:</p>
        <ul class="privacy-policy-text">
          <li>To create and manage organization accounts</li>
          <li>To assign appropriate user roles</li>
          <li>To facilitate visitor approval workflows</li>
          <li>To provide support and implementation services</li>
          <li>To monitor system usage and enhance security</li>
        </ul>
        <p class="fw-bold mb-1 privacy-policy-text">Data Security & Access:</p>
        <ul class="privacy-policy-text">
          <li>Only authorized users from your organization can access your data</li>
          <li>DNV does not use host data for advertising or marketing</li>
          <li>Data access is role-based and logged for auditability</li>
        </ul>
        <p class="fw-bold mb-1 privacy-policy-text">Data Storage:</p>
        <ul class="privacy-policy-text">
          <li>Hosted securely on cloud infrastructure within India or other compliant jurisdictions</li>
        </ul>
  
        <hr>
  
        <h6 class="fw-bold privacy-policy-text">2. Privacy Policy for Visitors</h6>
        <p class="privacy-policy-text" >This section applies to individuals who are visiting an organization using the VisitorBridge platform.</p>
        <p class="fw-bold mb-1 privacy-policy-text">Information We Collect:</p>
        <ul class="privacy-policy-text">
          <li>Full Name</li>
          <li>Contact Number</li>
          <li>Email Address</li>
          <li>Photograph</li>
          <li>Government ID details (e.g., Aadhaar, PAN, Driving License)</li>
          <li>Host Name and Department</li>
          <li>Purpose and duration of visit</li>
          <li>Declaration consent (if required)</li>
          <li>Safety video acknowledgment (if required)</li>
        </ul>
        <p class="fw-bold mb-1 privacy-policy-text">How We Use This Information:</p>
        <ul class="privacy-policy-text">
          <li>To authenticate and register your visit</li>
          <li>To notify your host</li>
          <li>To ensure security and compliance of the visited workplace</li>
          <li>To facilitate faster entry in future visits (if marked as favourite)</li>
        </ul>
        <p class="fw-bold mb-1 privacy-policy-text">Data Handling:</p>
        <ul class="privacy-policy-text">
          <li>The information is collected on behalf of the host organization</li>
          <li>Data is only accessible to authorized users within that organization</li>
          <li>Visitor data is not shared with third parties for advertising or profiling</li>
        </ul>
        <p class="fw-bold mb-1 privacy-policy-text">Data Retention & Security:</p>
        <ul class="privacy-policy-text">
          <li>Visitor data is encrypted in transit and at rest</li>
          <li>Access is restricted to approved roles (e.g., Admin, Super Admin)</li>
          <li>Blacklisted visitors will be flagged and blocked as per organization policy</li>
        </ul>
  
        <hr>
  
        <h6 class="fw-bold privacy-policy-text">3. General Terms for All Users</h6>
        <p class="fw-bold mb-1 privacy-policy-text">Data Hosting & Transfers:</p>
        <ul class="privacy-policy-text">
          <li>Data is hosted on secure, third-party cloud infrastructure within India or other permitted regions</li>
        </ul>
        <p class="fw-bold mb-1 privacy-policy-text">Policy Updates:</p>
        <ul class="privacy-policy-text">
          <li>This policy may be revised periodically. The updated version will be available on our website and app
            login page with the effective date.</li>
        </ul>
        <div class="text-center">
          <p class="fw-bold mb-1 privacy-policy-text">Contact Us:</p>
          <ul class="privacy-policy-text">
            <li>Email: <a href="mailto:support&#64;visitorbridge.in">support&#64;visitorbridge.in</a></li>
          </ul>
        </div>       
      </div>
  
    </div>
  </div>

  <!-- Color Grid -->
  <div class="position-fixed bottom-0 w-100">
    <div class="row g-0">
      <div class="col-4 one-grid"></div>
      <div class="col-4 two-grid"></div>
      <div class="col-4 three-grid"></div>
    </div>
  </div>
</div>